module.exports = __webpack_public_path__ + "static/media/story-page-image.b656375e.webp";